import type { DeepPartial } from '@luna/utils-ts';

import type { TitleDetail } from '../../types/TitleDetail';

export const titleDetailATConfig: DeepPartial<TitleDetail> = {
    applyDirectUrlToTitleDetails: true,
    formatStockExchangeValue: true,
    displayPositionPiecesQuantity: false,
    showCapitalGainsTax: true,
    findMatchingHeldTitles: true,
};
